import { render, staticRenderFns } from "./SessionInstructor.vue?vue&type=template&id=2ecbe62c&"
import script from "./SessionInstructor.vue?vue&type=script&lang=js&"
export * from "./SessionInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports